'use strict';

var ngModule = 'frontend.admin.users';

require('angular')
  .module(ngModule, [
    require('../../app/components')
  ])
  .factory('adminUserService', require('./users/service'))
  .component('adminUsers', require('./users'))
  .component('contactImport', require('./contact-import'))
  .component('managerImport', require('./manager-import'))
  .component('adminUsersCreate', require('./create'))
  .component('adminUsersUpdate', require('./update'))
  .component('changeManager', require('./change-manager'))
  .component('usersNavigation', require('./users-navigation'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/index.js
 ** module id = 139
 ** module chunks = 0
 **/